import { PaymentPlatform } from './payment';

export enum IFeature {
  REVIEWS = 'reviews',
  API_ACCESS = 'apiAccess',
  UNLIMITED_HOST = 'unlimitedHost',
  EXCLUSIVE_EXPERIENCE = 'exclusiveExperiences',
  DATA_PLUS = 'dataPlus',
  EXPERIENCE_COMMENTS = 'experienceComments',
  CUSTOM_BOOKING_EMAIL_MESSAGE = 'customBookingEmailMessage',
  SMS_NOTIFICATION = 'smsNotifications',
  EXPERIENCE_LISTING_TYPE = 'experienceListingType',
  LINK_OUT_RECOMMENDATIONS = 'linkOutRecommendations',
  ENHANCED_HOST_COMMISSION = 'enhancedHostCommission',
  ROOM_MEMBER_CHARGE = 'roomMemberCharge',
  PRICE_TIERS = 'priceTiers',
  OPERA = 'integrations:opera',
  STAYNTOUCH = 'integrations:stayntouch',
  MEWS = 'integrations:mews',
  SHOPPING_CART = 'shoppingCart',
  INFOR = 'integrations:infor',
  KICC = 'kicc',
  TEALIUM_ANALYTICS = 'integrations:tealiumAnalytics',
}

enum ITheme {
  DEFAULT = 'default',
  DARK = 'dark',
}

export interface IMedia {
  id: string;
  originalName: string;
  mimeType: string;
  fileSize: number;
  status: 'draft' | 'published';
  uploadedAt: string;
}

/** A top-level page of the storefront: a root catalog of its own, a tab after Browse and Schedule. */
export interface IStorefrontPage {
  catalogId: string;
  /** Listed but not shown to guests. */
  hidden: boolean;
}

/** The storefront's home (the Browse tab; null until one is set) and its other top-level pages, in tab order. */
export interface IStorefrontSettings {
  pages: IStorefrontPage[];
  rootCatalogId: string | null;
}

export interface IBrandSettings {
  countryCode: string;
  customStyle: string;
  designElement: {
    logoId: string | null;
    logo: IMedia | null;
    primaryColor: string | null;
    secondaryColor: string | null;
    buttonColor: string | null;
    primaryFont: string | null;
    secondaryFont: string | null;
    theme: ITheme | null;
  };
  features: {
    active: IFeature[];
    hostsLimit: number;
    updatedAt: string;
  };
  name: string;
  paymentPlatform: PaymentPlatform;
  promotion: unknown;
  templateElement: {
    hero: {
      desktop: unknown;
    };
  };
  shouldValidateComplimentaryBooking: {
    roomCharge: boolean;
    memberCharge: boolean;
  };
  storefront?: IStorefrontSettings;
  /** The page(s) the brand's sitemap advertises its listings under; the first one is canonical. */
  seo?: {
    sitemapBaseUrls?: string[];
  };
}
